<script>
import ZDefaultData from '../default-data/main'
import pagination from '../../el-pagination'
import { getLastLevel, getHandleColumns, isPlainObject } from './util'
export default {
  name: 'ZTable',
  components: {
    ZDefaultData,
    [pagination.name]: pagination
  },
  props: {
    columns: {
      type: Array,
      required: true
    },
    data: {
      type: Array,
      required: true
    },
    selection: {
      type: Boolean,
      default: false
    },
    showColumnHandle: {
      type: Boolean,
      default: false
    },
    showHeader: {
      type: Boolean,
      default: false
    },
    pagination: {
      type: [Boolean, Object],
      default: () => {
        return {
          pageNum: 1, // 页码
          pageSize: 20, // 每页大小
          total: 0 // 全部数据条数
        }
      },
      validator(val) {
        if (isPlainObject(val)) {
          return 'pageNum' in val && 'pageSize' in val
        }
        return val === false
      }
    },
    autoCalcTableHeight: {
      type: Boolean,
      default: false
    },
    keepScrollPos: {
      type: Boolean,
      default: false
    },
    maxHeight: {
      type: Number
    },
    paginationComponentData: {
      type: Object,
      default: () => ({})
    },
    customEmpty: {
      type: Boolean, // 是否展示统一缺省
      default: false
    },
    customDefault: {
      type: Object, // 自定义统一缺省页
      default: () => ({
        height: '490px',
        img: '',
        title: '',
        text: '',
        buttons: []
      })
    }
  },
  data() {
    return {
      drawer: false,
      direction: 'rtl',
      checkList: [],
      page: {},
      tableHeight: null,
      originalScrollPos: 0
    }
  },
  computed: {
    paginationH() {
      return this.pagination ? 80 : 16
    },
    tableColumns() {
      if (!this.showColumnHandle) return this.restColumns
      if (this.moreLevel) {
        return getHandleColumns(this.restColumns, this.checkList)
      }
      const columns = this.restColumns.filter(i => this.checkList.includes(i.label) || i.hideColumnHandle)
      if (columns.every(i => !i.minWidth)) {
        return columns.map(i => {
          const { width, ...other } = i
          return Object.assign({}, other, width ? { minWidth: width } : {})
        })
      }
      console.log(columns, 'columns')
      return columns
    },
    lastColumn() {
      return this.columns.slice(-1).map(i => {
        if (!i.slotHeaderName) {
          return { ...i, slotHeaderName: i.prop + 'Header' }
        }
        return i
      })[0]
    },
    restColumns() {
      return this.columns.slice(0, this.columns.length - 1)
    },
    lastLevelColumns() {
      return getLastLevel(this.restColumns)
    },
    moreLevel() {
      return this.restColumns.some(i => i.children && i.children.length)
    },
    lastColumnScopedHeader() {
      const { $scopedSlots, lastColumn, showColumnHandle, openDrawer } = this
      if (lastColumn && showColumnHandle) {
        const fn =
          $scopedSlots[lastColumn.slotHeaderName] ||
          function(props) {
            return <span>{props.column.label}</span>
          }
        return props => {
          return (
            <div style="display: flex; align-items: center">
              {fn(props)}
              <i class="el-icon-setting fc-primary" style="cursor: pointer; margin-left: 10px" onClick={openDrawer} />
            </div>
          )
        }
      }
      return null
    }
  },
  watch: {
    lastLevelColumns: {
      handler(val) {
        if (!this.checkList.length) {
          this.checkList = val.filter(i => !i.hideColumnHandle).map(i => i.label)
        }
      },
      immediate: true
    }
  },
  created() {},
  mounted() {
    this.getTableHeight()
  },
  activated() {
    if (this.keepScrollPos) {
      setTimeout(() => {
        this.resetScrollPos()
      }, 10)
    }
  },
  methods: {
    saveScrollPos() {
      const el = this.$refs.elTable.$el
      if (el) {
        const targetEl = el.querySelector('.el-table__body-wrapper')
        this.originalScrollPos = (targetEl && targetEl.scrollTop) || 0
      }
    },
    resetScrollPos() {
      const el = this.$refs.elTable.$el
      if (el) {
        const targetEl = el.querySelector('.el-table__fixed-body-wrapper')
        const targetEl1 = el.querySelector('.el-table__body-wrapper')
        if (targetEl) {
          targetEl.scrollTop = this.originalScrollPos
        }
        if (targetEl1) {
          targetEl1.scrollTop = this.originalScrollPos
        }
      }
    },
    getTableHeight() {
      if (!this.autoCalcTableHeight) return
      this.$nextTick(() => {
        const el = this.$refs.tableWrap
        if (el) {
          const pos = el.getBoundingClientRect()
          const h = window.innerHeight - pos.top - this.paginationH
          this.tableHeight = h < 100 ? 300 : h
        }
      })
    },
    disabledHandleColumn(item) {
      return this.checkList.includes(item.label) && this.checkList.length === 1
    },
    openDrawer() {
      this.drawer = true
    },
    closeDrawer() {
      this.drawer = false
    },
    changeCheckList(val) {
      this.checkList = val
    },
    tableRef() {
      return this.$refs.elTable
    },
    findBodyWrapper(el) {
      let target = null
      const f = arr => {
        let dom = null
        for (let item of arr) {
          if (item && item.className && item.className.indexOf('body-wrapper') > 0) {
            dom = item
            break
          } else {
            dom = f(item.childNodes)
            if (dom) {
              break
            }
          }
        }
        return dom
      }
      for (let item of el.children) {
        if (item && item.className && item.className.indexOf('body-wrapper') > 0) {
          target = item
          break
        } else {
          target = f(item.childNodes)
          if (target) {
            break
          }
        }
      }
      return target
    },
    handlePageChange(pageNum) {
      if (this.findBodyWrapper(this.$refs.elTable.$el)) {
        this.findBodyWrapper(this.$refs.elTable.$el).scrollTop = 0
      }
      this.$emit('update:pagination', {
        ...this.pagination,
        pageNum
      })
      // 页码发生变化
      this.$emit('page-change')
    },
    handlePageSizeChange(pageSize) {
      if (this.findBodyWrapper(this.$refs.elTable.$el)) {
        this.findBodyWrapper(this.$refs.elTable.$el).scrollTop = 0
      }
      this.$emit('update:pagination', {
        ...this.pagination,
        pageNum: 1, // 页码
        pageSize: pageSize, // 每页大小
        total: this.pagination.total // 全部数据条数
      })
      this.$emit('page-change')
    }
  },
  render(h) {
    const {
      data,
      $listeners,
      $attrs,
      selection,
      showColumnHandle,
      drawer,
      direction,
      lastLevelColumns,
      disabledHandleColumn,
      checkList,
      closeDrawer,
      changeCheckList,
      $scopedSlots,
      tableColumns,
      lastColumn,
      handlePageSizeChange,
      pagination,
      handlePageChange,
      tableHeight,
      autoCalcTableHeight,
      customEmpty,
      customDefault,
      showHeader
    } = this
    const other = {
      on: $listeners,
      attrs: {
        ...(autoCalcTableHeight && tableHeight ? { height: tableHeight } : {}),
        ...$attrs
      }
    }
    const lastColumnScoped = {
      ...$scopedSlots
    }
    if (this.lastColumnScopedHeader) {
      lastColumnScoped[lastColumn.slotHeaderName] = this.lastColumnScopedHeader
    }
    const paginationData = {
      attrs: {
        ...this.paginationComponentData
      }
    }
    console.log(tableColumns, 'tableColumns', $scopedSlots)
    if (data.length > 0 || customEmpty || showHeader) {
      return (
        <div ref="tableWrap">
          <el-table
            ref="elTable"
            data={data}
            // style={this.maxHeight ? 'width: 100%;' : 'min-height:200px;width: 100%;'}
            style="width: 100%"
            {...other}
            max-height={this.maxHeight}
          >
            {selection && (
              <el-table-column
                type="selection"
                width="65"
                selectable={other.attrs && other.attrs.selectable ? other.attrs.selectable : () => true}
              />
            )}
            {tableColumns.map(item => {
                item.renderHeader = $scopedSlots[item.prop + 'Header'] ?  $scopedSlots[item.prop + 'Header'] : null
                return <el-table-column attrs={item} label={item.label} scopedSlot={$scopedSlots[item.prop]} />
              })}
            {lastColumn && <el-table-column attrs={lastColumn} label={lastColumn.label}  scopedSlot={$scopedSlots[lastColumn.prop]}  />}
            {this.$slots.empty && <div slot="empty">{this.$slots.empty}</div>}
          </el-table>
          {pagination !== false && (
            <div class="pagination-container">
              <el-pagination
                layout="total, sizes, prev, pager, next, jumper"
                currentPage={pagination.pageNum}
                background
                pageSizes={pagination.pageSizes || [10, 20, 50, 100, 200]}
                pageSize={pagination.pageSize}
                total={parseInt(pagination.total)}
                on={{
                  'size-change': handlePageSizeChange,
                  'current-change': handlePageChange
                }}
                {...paginationData}
              ></el-pagination>
            </div>
          )}

          {showColumnHandle && (
            <el-drawer
              title="表格设置"
              visible={drawer}
              direction={direction}
              custom-class="z-table__drawer"
              on={{ 'update:visible': closeDrawer }}
            >
              <div class="z-table__drawer__body">
                <span class="z-table__drawer__tip">根据用户设置自定义表格列展示</span>
                <el-checkbox-group value={checkList} on={{ input: changeCheckList }}>
                  {lastLevelColumns
                    .filter(i => !i.hideColumnHandle)
                    .map(i => (
                      <el-checkbox key={i.label} label={i.label} disabled={disabledHandleColumn(i)} />
                    ))}
                </el-checkbox-group>
              </div>
            </el-drawer>
          )}
        </div>
      )
    } else {
      return (
        <div style="min-height:200px;position:relative">
          <ZDefaultData custom={customDefault}></ZDefaultData>
        </div>
      )
    }
  }
}
</script>
<style lang="scss" scoped>
.z-table__drawer {
  .el-drawer__header {
    margin-bottom: 10px;
    border-bottom: 1px solid $--border-color-base;
    padding: $--base-padding;
    font-size: 18px;
  }
  &__body {
    padding: 0 $--base-padding;
    display: flex;
    flex-direction: column;
  }
  &__tip {
    color: #ced4da;
  }
  .el-checkbox-group {
    margin-top: $--base-margin;
    display: flex;
    flex-direction: column;
  }
  .el-checkbox {
    margin-bottom: $--base-margin;
  }
  :focus {
    outline: 0;
  }
}
.pagination-container {
  text-align: center;
  margin-top: 16px;
  /deep/.el-pagination__sizes {
    position: relative;
    transform: translateY(-2px);
  }
  /deep/.el-pagination__jump {
    .el-pagination__editor {
       position: relative;
    transform: translateY(-2px);
    }
  }
}
</style>
